module.exports = __webpack_public_path__ + "img/member-verify-icon-2.e76e86e7.png";